import React from "react";

function Card({ children, className }: any) {
  return <div className={`bg-white shadow p-4  ${className}`}>{children}</div>;
}

export default Card;
